/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".dropdown-div{width:200px}.ms-PeoplePicker{width:100%}"}]);
/* tslint:enable */